<template>
    <p>FAQ</p>
</template>
